import type { FC } from 'react';
import { useTheme } from 'styled-components';

import { ButtonHeart } from '@/components/buttons';
import { useGetCommonStore } from '@/store';
import { Spinner } from '@/styles/common';
import { ScFavoriteButton } from './styled';

interface FavoriteButtonProps {
  isFavorite: boolean;
  handleFavorite: () => void;
}

export const FavoriteButton: FC<FavoriteButtonProps> = ({
  isFavorite,
  handleFavorite,
}) => {
  const useCommonStore = useGetCommonStore();

  const pendingFavoriteGames = useCommonStore.use.pendingFavoriteGames();

  const { blackColor, whiteColor, secondaryColor } = useTheme();

  return (
    <ScFavoriteButton isFavorite={isFavorite} onClick={handleFavorite}>
      {pendingFavoriteGames ? (
        <Spinner
          background={isFavorite ? whiteColor : blackColor}
          center
          color={isFavorite ? secondaryColor : whiteColor}
          size={20}
        />
      ) : (
        <ButtonHeart active={isFavorite} height={24} width={24} />
      )}
    </ScFavoriteButton>
  );
};
